import * as REDUX_TYPES from '../types'

const INITIAL_STATE = {
    logMessages: []
}

const logReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case REDUX_TYPES.LOG.ADD_LOG_MESSAGE:
            return {
                ...state,
                logMessages: [...state.logMessages, action.logMessage],
            }
        case REDUX_TYPES.LOG.RESET:
            return INITIAL_STATE
        default:
            return state
    }
}
export default logReducer